// extracted by mini-css-extract-plugin
export default {"cls1":"PaperNewsStory-cls1_GrE","cls2":"PaperNewsStory-cls2_sac PaperNewsStory-cls1_GrE"};